import { serviceRequest } from 'utils/http';
import { ChangeForgottenPasswordDto, SiteEmployeeService } from 'common/api';

export function changeForgottenPasswordAPI(
  bodyRequest: ChangeForgottenPasswordDto
) {
  return serviceRequest(() =>
    SiteEmployeeService.siteEmployeeControllerChangeForgottenPassword(
      bodyRequest
    )
  );
}
